import { Routes, Route } from 'react-router-dom';
import { FormContextProvider } from 'contexts/FormContext';
import MyMigrationFormPage from './migration-form';

export default function MyMigrationRoutes() {
  return (
    <FormContextProvider market="my">
      <Routes>
        <Route path="migration-form" element={<MyMigrationFormPage />} />
      </Routes>
    </FormContextProvider>
  );
}
